// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.recalls.PatientRecallDetailResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientRecallDetailResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Date })
	appointmentDate!: Date | null;

	@GandalfProperty({ designType: Number })
	appointmentId!: number | null;

	@GandalfProperty({ designType: String })
	appointmentLocation!: string | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: Number })
	encounterTemplateId!: number | null;

	@GandalfProperty({ designType: Number })
	patientRecallId!: number | null;

	@GandalfProperty({ designType: Number })
	practiceLocationId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	recallDate!: Date | null;

	@GandalfConstantDecorator(constants.RecallStatus)
	@GandalfProperty({ designType: constants.RecallStatus })
	status!: constants.RecallStatus | null;

}
